import { fetchSystemInfoQueryOptions } from '@/api/systemInfo';
import { Box, Divider, Typography } from '@mui/material';
import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { useAuth } from 'react-oidc-context';

import packageJson from '../../package.json';

export const Route = createFileRoute('/help')({
    component: HelpComponent,
})

function HelpComponent() {

    const auth = useAuth()

    const systemInfoQuery = useSuspenseQuery(fetchSystemInfoQueryOptions(auth.isAuthenticated))
    const systemInfo = systemInfoQuery.data

    return (
        <>
            <Box sx={{ p: 1 }}>
                <Typography variant="h6" sx={{ pt: 1 }}>Dokumentation / Hilfe</Typography>
                <p>Die Grundfunktionen und Prozesse sind in der Dokumentation (<a href="https://gitlab.com/scoregat/documentation/-/wikis/home" target="_new" >LINK</a>) beschrieben. Dort findet ihr auch die Informationen zu aktuellen Änderungen und Erweiterungen.</p>

                <Divider />
                <Typography variant="h6" sx={{ pt: 3 }}>SCOREG-Beauftragte</Typography>
                <p>Für Fragen wende dich bitte an den SCOREG-Beauftragten deiner Organisation / Bundesland</p>
                <table>
                    <thead>
                        <tr>
                            <td><b>Organisation</b></td>
                            <td><b>Ansprechperson</b></td>
                            <td><b>E-Mail</b></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Gildeverband</td>
                            <td>Markus Schicht</td>
                            <td><a href="mailto:gilde@scoreg.at">gilde@scoreg.at</a></td>
                        </tr>
                        <tr>
                            <td>Südtiroler Pfadfinderschaft</td>
                            <td>Robert Niedermair</td>
                            <td><a href="mailto:suedtirol@scoreg.at">suedtirol@scoreg.at</a></td>
                        </tr>
                        <tr>
                            <td>LV Burgenland</td>
                            <td>Philipp Pertl</td>
                            <td><a href="mailto:burgenland@scoreg.at">burgenland@scoreg.at</a></td>
                        </tr>
                        <tr>
                            <td>LV Kärnten</td>
                            <td>Gerhard Himmer</td>
                            <td><a href="mailto:kaernten@scoreg.at">kaernten@scoreg.at</a></td>
                        </tr>
                        <tr>
                            <td>LV Oberösterreich</td>
                            <td>Hans Bachner</td>
                            <td><a href="mailto:oberoesterreich@scoreg.at">oberoesterreich@scoreg.at</a></td>
                        </tr>
                        <tr>
                            <td>LV Salzburg</td>
                            <td>Rudi Erda</td>
                            <td><a href="mailto:salzburg@scoreg.at">salzburg@scoreg.at</a></td>
                        </tr>
                        <tr>
                            <td>LV Steiermark</td>
                            <td>Johannes Grasegger</td>
                            <td><a href="mailto:ticket-steiermark@scoreg.at">ticket-steiermark@scoreg.at</a></td>
                        </tr>
                        <tr>
                            <td>LV Tirol</td>
                            <td>Tarek Ayoub</td>
                            <td><a href="mailto:tirol@scoreg.at">tirol@scoreg.at</a></td>
                        </tr>
                        <tr>
                            <td>LV Vorarlberg</td>
                            <td>Stefan Gisinger</td>
                            <td><a href="mailto:vorarlberg@scoreg.at">vorarlberg@scoreg.at</a></td>
                        </tr>
                        <tr>
                            <td>LV Wien</td>
                            <td>Robert Medlitsch</td>
                            <td><a href="mailto:ticket-wien@scoreg.at">ticket-wien@scoreg.at</a></td>
                        </tr>
                        <tr>
                            <td>Bezirk Mödling</td>
                            <td>Gerald Stockinger</td>
                            <td><a href="mailto:niederoesterreich@scoreg.at">niederoesterreich@scoreg.at</a></td>
                        </tr>

                    </tbody>
                </table>
                <Divider />
                <Typography variant="h6" sx={{ pt: 3 }}>Information zu Schutzrechten</Typography>
                <p>Adressdaten: &copy; Österreichisches Adressregister, Stichtagsdaten vom 01.10.2024</p>
                <p>Feiertage: &copy; https://www.openholidaysapi.org/</p>
                <Divider />
                <Typography variant="h6" sx={{ pt: 3 }}>Versionsinformationen</Typography>
                <p>{'Frontend: ' + packageJson.version + ' - ' + VITE_BUILD_DATE}</p>
                <p>{'Backend: ' + systemInfo.version + ' - ' + systemInfo?.timestamp}</p>
            </Box>
        </>
    )
}
